import { Box, Card, Stack, Text } from "@mantine/core";
import DynamicFormBuilder from "../FormBuilder/DynamicFormBuilder.component";
import { useSingleForm } from "../../../../api/services/useServices";
import axios from "../../../../libs/axios";
import { store } from "../../../../store/useStore";
import { useSearchParams } from "react-router-dom";
import { Else, If, Then } from "react-if";
import { IconAlertTriangle } from "@tabler/icons-react";

export default function LeadSignupForm() {
  const [searchParams] = useSearchParams();

  const { data: singleForm, isSuccess: isFormLoaded } = useSingleForm({
    params: {
      module_type: "lead",
      ...(searchParams.has("form_identifier") && {
        identifier: searchParams.get("form_identifier"),
      }),
    },
  });

  const handleSubmit = async (values: any) => {
    try {
      const active_device = store.auth.activeDeviceIdentifier();

      const res = await axios.get(
        `/public/lead/${values?.data?.identifier}/assigned-staff`,
        {
          headers: {
            "fi-device-number": active_device,
          },
        }
      );

      localStorage.setItem(
        "lead_assigned_staff",
        JSON.stringify(res?.data?.data?.staffInfo)
      );
    } catch (error) {
      console.error("Error creating entry:", error);
    }
  };

  return (
    <Card radius="md">
      <If condition={isFormLoaded}>
        <Then>
          <DynamicFormBuilder
            singleForm={singleForm}
            onSubmit={{
              successPage: "/lead-signup/success",
              callback: (values) => {
                handleSubmit(values);

                // localStorage.setItem("isLead", "true-signup");
              },
            }}
            isPublicForm
          />
        </Then>
        <Else>
          <Stack py={40} align="center">
            <Box
              p={10}
              w={60}
              h={60}
              display="flex"
              style={{
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 100,
                backgroundColor: "#EEEE",
              }}
            >
              <IconAlertTriangle size={32} />
            </Box>
            <Text>Form not found</Text>
          </Stack>
        </Else>
      </If>
    </Card>
  );
}
